import { render, staticRenderFns } from "./scroll-x-navbar-cmp.vue?vue&type=template&id=5281a901&scoped=true"
import script from "./scroll-x-navbar-cmp.vue?vue&type=script&lang=js"
export * from "./scroll-x-navbar-cmp.vue?vue&type=script&lang=js"
import style0 from "./scroll-x-navbar-cmp.vue?vue&type=style&index=0&id=5281a901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281a901",
  null
  
)

export default component.exports